import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=2ff79792&scoped=true"
import script from "./tooltip.vue?vue&type=script&lang=ts"
export * from "./tooltip.vue?vue&type=script&lang=ts"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=2ff79792&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff79792",
  null
  
)

export default component.exports